<h3 mat-dialog-title class="title">
  {{ data.title || 'catalog.changeSets.viewChangeSetChangesDialog.title' | translate:{ version: data.selectedVersion } }}
</h3>

<mat-dialog-content class="changes-content">
  <div class="item-list">
    <strong *ngIf="!data.message && data.itemList.length">
      {{ 'catalog.changeSets.viewChangeSetChangesDialog.pendingChanges' | translate }}
    </strong>

    <strong *ngIf="!data.message && !data.itemList.length">
      {{ 'catalog.changeSets.viewChangeSetChangesDialog.noChanges' | translate }}
    </strong>

    <div [innerHTML]="data.message"></div>

    <div class="item-type" *ngFor="let itemType of itemTypeMap | keyvalue">
      <strong>
        {{ itemType.key }}
      </strong>

      <ul>
        <li *ngFor="let item of itemType.value">
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
  <txp-button class="clear-changes-btn"
              *ngIf="!data.confirmObservable && data.itemList.length"
              (click)="onClearChanges()"
              data-qa-label="ClearChanges"
              [style]="buttonStyle.PRIMARY">
    {{ 'catalog.changeSets.viewChangeSetChangesDialog.clearAllChanges' | translate }}
  </txp-button>
</mat-dialog-content>

<mat-dialog-actions>
  <txp-button (click)="onCancel()"
              [disabled]="isLoading"
              data-qa-label="CancelButton"
              [style]="buttonStyle.SECONDARY">
    {{ 'form.button.cancel' | translate }}
  </txp-button>
  <txp-button data-qa-label="ContinueButton"
              *ngIf="data.confirmObservable"
              [style]="buttonStyle.PRIMARY"
              [loading]="isLoading"
              (click)="onAction()">
    {{ data.confirmText }}
  </txp-button>
</mat-dialog-actions>
